import { Component, Vue, Prop } from 'vue-property-decorator'
import moment from 'moment'

import EventModel, { EventStatus } from '@/core/models/Event'
import { TABLES_ALL } from '@/core/models/Room'


@Component
export default class EventsList extends Vue {
  public EventStatus: any = EventStatus

  @Prop({ required: true })
  public events: Array<any>

  @Prop({ required: true })
  public holiday: Boolean = false


  public getEventCardColor (event: any): string {
    if (event.status === EventStatus.CANCELED) {
      return 'blue-grey lighten-4'
    }
    if (event.status === EventStatus.PREORDERED) {
      return this.isPreorderDue(event) ? 'deep-orange darken-2' : 'orange darken-3'
    }
    return event.room_color
  }

  public getEventCardClass (event: any): {[key: string]: boolean} {
    return {
      'preorder-event-card': event.status === EventStatus.PREORDERED,
      'preorder-event-card--due': this.isPreorderDue(event),
    }
  }

  public getPreorderChipText (event: any): string {
    const confirmation = this.getPreorderConfirmationText(event.status_confirmation_date)
    if (!confirmation) {
      return 'Предзаказ: дата подтверждения не указана'
    }
    return this.isPreorderDue(event)
      ? `Предзаказ: подтвердить до ${confirmation}`
      : `Предзаказ до ${confirmation}`
  }

  public getFormattedDate (isoDate: string) {
    const date = new Date(isoDate)
    const thisDayDate = new Date(this.$route.params.date)
    return date.toLocaleDateString() !== thisDayDate.toLocaleDateString()
      ? date.toLocaleString()
      : date.toLocaleTimeString()
  }

  public getDateTitle (): string {
    const routeDate = new Date(this.$route.params.date)
    return moment(routeDate.toISOString()).format('LL')
  }

  public getTablesNumbers (event: any): string {
    if (event.table_numbers === 'all') {
      return TABLES_ALL
    }
    return event.tables_name + ': ' + event.table_numbers
  }

  public getRoomOptions (event: any): string {
    return event.options
      ? event.options.map((row: any) => row.name)
      : []
  }

  public getPersonsAsText (event: any): string {
    const persons = []
    for (const person of event.persons) {
      const parts = []
      if (person.count) { parts.push(`${person.count} чел.`) }
      if (person.price) { parts.push(`${person.price} р.`) }
      persons.push(parts.join(' х '))
    }
    return persons && persons.length
      ? `Гости: ${persons.join(', ')}`
      : 'Гости: -'
  }

  public gotoEvent (eventId: string) {
    this.$router.push({ name: 'showEvent', params: { id: eventId } })
  }

  public showPayments (event: EventModel): boolean {
    const { needPaid, paid } = this.aggregatePayments(event)
    return !!needPaid || !!paid
  }

  public getPaymentsAsText (event: EventModel): string {
    let text = ''
    const { needPaid, paid } = this.aggregatePayments(event)
    text = needPaid
      ? `Оплачено: ${paid}₽ из ${needPaid}₽`
      : `Оплачено: ${paid}₽`
    return text
  }

  private aggregatePayments (event: EventModel): {needPaid: number | null, paid: number | null} {
    let paid = 0
    for (const [index, payment] of event.payments.entries()) {
      if (+payment.amount) {
        paid += +payment.amount
      }
      //   if (!payment.amount && !payment.date && !payment.owner && !payment.type) {
    }

    let optionsSummary = 0
    if (event.options && event.options.length > 0) {
      for (const [index, option] of event.options.entries()) {
        if (Number.parseInt(option.amount)) {
          optionsSummary += +option.amount
        }
      }
    }

    let personsSummary = 0
    let error = true
    if (event.persons && event.persons.length > 0) {
      for (const [index, person] of event.persons.entries()) {
        if (Number.parseInt(person.count) && Number.parseInt(person.price)) {
          error = false
          personsSummary += +person.count * +person.price
        }
      }
    }

    let needPaid = null
    if (!error) {
      needPaid = personsSummary + optionsSummary
    }

    return { needPaid, paid }
  }

  public showRefunds (event: EventModel): boolean {
    const { needRefund, refunded } = this.aggregateRefunds(event)
    return !!needRefund || !!refunded
  }

  public getRefundsAsText (event: EventModel): string {
    let text = ''
    const { needRefund, refunded } = this.aggregateRefunds(event)
    text = needRefund
      ? `Возвращено: ${refunded}₽ из ${needRefund}₽`
      : `Возвращено: ${refunded}₽`
    return text
  }

  private aggregateRefunds (event: EventModel): {needRefund: number | null, refunded: number | null} {
    let refunded = 0
    if (event.refunds) {
      for (const [index, refund] of event.refunds.entries()) {
        if (+refund.amount) {
          refunded += +refund.amount
        }
      }
    }

    let needRefund = 0
    for (const [index, payment] of event.payments.entries()) {
      if (+payment.amount) {
        needRefund += +payment.amount
      }
    }

    return { needRefund, refunded }
  }

  private isPreorderDue (event: any): boolean {
    if (event.status !== EventStatus.PREORDERED) {
      return false
    }
    if (!event.status_confirmation_date || isNaN(Date.parse(event.status_confirmation_date))) {
      return true
    }
    return moment(event.status_confirmation_date).isSameOrBefore(moment().endOf('day'))
  }

  private getPreorderConfirmationText (date: string | null): string | null {
    if (!date || isNaN(Date.parse(date))) {
      return null
    }
    return moment(date).format('DD.MM.YYYY')
  }
}
